import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const DEFAULT_CUSTOM_PLAN = {
  canone_net: "",
  periodicita: "mensile",
  max_collaboratori: "",
  max_interni: "",
  max_consultazione: "",
  retention_days: 365,
  includes_agent_flow: true,
  includes_collab_flow_module: true,
  includes_plurimandatari: false,
};

const RETENTION = [
  { v: 183, l: "6 mesi" }, { v: 365, l: "12 mesi" }, { v: 730, l: "2 anni" },
  { v: 1825, l: "5 anni" }, { v: 3650, l: "10 anni" },
];

const LIMITS = [
  { k: "max_collaboratori", l: "Max collaboratori" },
  { k: "max_interni", l: "Max utenze interne" },
  { k: "max_consultazione", l: "Max consultazione" },
];

const FEATURES = [
  { k: "includes_agent_flow", l: "Flusso di cassa agente" },
  { k: "includes_collab_flow_module", l: "Modulo flusso collaboratori" },
  { k: "includes_plurimandatari", l: "Plurimandatari (multi-compagnia)" },
];

export const toFormPlan = (cp) => ({
  ...DEFAULT_CUSTOM_PLAN,
  ...(cp || {}),
  max_collaboratori: cp?.max_collaboratori ?? "",
  max_interni: cp?.max_interni ?? "",
  max_consultazione: cp?.max_consultazione ?? "",
});

export const CustomPlanFields = ({ plan, onChange }) => {
  const set = (k, v) => onChange({ ...plan, [k]: v });
  return (
    <div className="col-span-2 grid grid-cols-2 gap-3 rounded-lg border border-amber-200 bg-amber-50/40 p-3" data-testid="custom-plan-fields">
      <div>
        <Label>Canone netto (€) *</Label>
        <Input type="number" step="0.01" min="0" value={plan.canone_net} onChange={(e) => set("canone_net", e.target.value)} data-testid="custom-canone" />
      </div>
      <div>
        <Label>Periodicità</Label>
        <select className="w-full border border-slate-200 rounded-md h-10 px-2 text-sm bg-white" value={plan.periodicita} onChange={(e) => set("periodicita", e.target.value)} data-testid="custom-periodicita">
          <option value="mensile">Mensile</option>
          <option value="annuale">Annuale</option>
        </select>
      </div>
      {LIMITS.map((f) => (
        <div key={f.k}>
          <Label>{f.l}</Label>
          <Input type="number" min="0" placeholder="illimitato" value={plan[f.k]} onChange={(e) => set(f.k, e.target.value)} data-testid={`custom-${f.k}`} />
        </div>
      ))}
      <div>
        <Label>Storico conservato</Label>
        <select className="w-full border border-slate-200 rounded-md h-10 px-2 text-sm bg-white" value={plan.retention_days} onChange={(e) => set("retention_days", Number(e.target.value))} data-testid="custom-retention">
          {RETENTION.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
        </select>
      </div>
      <div className="col-span-2 text-[11px] text-slate-500">Lascia vuoto un limite per renderlo illimitato; 0 = tipologia non prevista.</div>
      {FEATURES.map((f) => (
        <label key={f.k} className="col-span-2 flex items-center justify-between text-sm text-slate-700">
          {f.l}
          <Switch checked={!!plan[f.k]} onCheckedChange={(v) => set(f.k, v)} data-testid={`custom-${f.k}`} />
        </label>
      ))}
    </div>
  );
};

export const BonificoFields = ({ form, onChange }) => {
  const set = (k, v) => onChange({ ...form, [k]: v });
  return (
    <>
      <div>
        <Label>Prossima scadenza *</Label>
        <Input type="date" value={form.prossima_scadenza || ""} onChange={(e) => set("prossima_scadenza", e.target.value)} data-testid="custom-scadenza" />
      </div>
      <label className="flex items-end gap-2 pb-2 text-sm text-slate-700">
        <Switch checked={!!form.bonifico_pagato} onCheckedChange={(v) => set("bonifico_pagato", v)} data-testid="custom-pagato" />
        Periodo corrente pagato
      </label>
      <div>
        <Label>Giorni di tolleranza</Label>
        <Input type="number" min="0" value={form.bonifico_grace_days ?? 7} onChange={(e) => set("bonifico_grace_days", e.target.value)} data-testid="custom-grace" />
      </div>
      <div>
        <Label>Promemoria (giorni prima)</Label>
        <Input type="number" min="0" value={form.bonifico_reminder_days ?? 7} onChange={(e) => set("bonifico_reminder_days", e.target.value)} data-testid="custom-reminder" />
      </div>
    </>
  );
};
